const ContactUsValidationMessages = {
    'required.email': 'Unesi validnu email adresu.',
    'email.email': 'Unesi validnu email adresu.',
    'required.subject': 'Izaberi korisnika.',
    'required.message': 'Unesi poruku.',
    'max.message': 'Poruka može da ima maksimalno 500 karaktera.'
};

export default ContactUsValidationMessages;